'use client';
import React from 'react';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import { Box, Stack } from '@mui/material';
import CustomImage from '@components/CustomImage';
import { Mobile } from '@components/Mobile';
import { Desktop } from '@components/Desktop';
import cn from './style.module.scss';
export default function WharfStory(props: MarketingPageComponentProps) {
  return (
    <Stack component="section" className={cn.wharfStoryWrapper}>
      <Box className={cn.wharfStoryInner}>
        <Box className={cn.wharfStoryStory}>
          <Mobile>
            <CustomImage
              src={props.images.ransome_wharf_story_banner?.mobileSrc || ''}
              alt={'BrookGreen Introduction Image'}
              width={768}
              height={768}
            />
          </Mobile>
          <Desktop>
            <CustomImage
              src={props.images.ransome_wharf_story_banner?.src || ''}
              alt={'BrookGreen Introduction Image'}
              width={768}
              height={768}
            />
          </Desktop>
        </Box>
      </Box>
    </Stack>
  );
}
